import { useMatch } from 'react-router-dom'
import { RootRoute } from '../../pages'

export const useIsSettings = () => {
  const isSettings = useMatch({ path: RootRoute.Settings, end: false })
  const isApps = useMatch({ path: RootRoute.Apps, end: false })

  return !!isSettings || !!isApps
}
